import React, { useState } from 'react'
import Select from 'react-select'
import { useSnackbar } from 'notistack'

import { usePet, useToggle, notifOps } from '../../modules'

import Modal from "../resusable/modal"
import Permissions from './permissions'

const EditUser = ({ toggle, user, visible, onPerform }) => {
    const [name, setName] = useState(user?.name)
    const [username, setUserName] = useState(user?.username)
    const [type, setType] = useState({ label: user?.type?.replace(user?.type?.charAt(0), user?.type?.charAt(0).toUpperCase()), value: user?.type })
    const [password, setPassword] = useState()
    const [conf, setConf] = useState()

    const [stations, setStations] = useState([])
    const [stores] = useState([])

    const [permissionsModal, togglePermissionsModal] = useToggle()

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()

    const addPermission = station => {
        setStations([...stations, station])
    }

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break
                
            case 'username':
                setUserName(e.target.value)
                break
            
            case 'password':
                setPassword(e.target.value)
                break
        
            case 'conf':
                setConf(e.target.value)
                break

            default:
                break
        }
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Changes have been saved', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('editUser', {
        id: user?._id,
        name,
        username,
        password: password?.toString(),
        type: type?.value
    }, { notify: true, callback: onComplete, manual: true })

    return (
        <Modal
            h="h-auto"
            w="w-1/3"
            align="items-start"
            top="mt-10"
            bottom="pb-10"
            title="Edit User"
            toggle={toggle}
            visible={visible}>
            <div className="divide-y divide-light-gray-400">
                <Permissions
                    onOk={addPermission}
                    visible={permissionsModal}
                    toggle={togglePermissionsModal} />
                <div>
                    <div>
                        <p className="font-bold my-3">User Details</p>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Name
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-first-name" 
                                    type="text" 
                                    value={ name }
                                    name="name"
                                    placeholder="Simon Kamau" />
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                    Username
                                </label>
                                <input value={ username } onChange={ modify } name="username" className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-username" type="text" placeholder="username" />
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-4">
                            <div className="w-full md:w-2/3 px-3">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-email">
                                    Permissions
                                </label>
                                <Select
                                    value={ type }
                                    onChange={ setType }
                                    options={ ['Cashier', 'Waiter', 'Admin'].map(prm => ({ label: prm, value: prm.toLowerCase() }))}
                                    placeholder="Permissions" />
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password">
                                    { type?.value === 'waiter' ? 'PIN' : 'Password' }
                                </label>
                                <input value={ password } onChange={ modify } name='password' className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-password" type="password" placeholder="**********" />
                            </div>
                            <div className="w-full md:w-1/2 px-3">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password-conf">
                                    Confirm { type?.value === 'waiter' ? 'PIN' : 'Password' }
                                </label>
                                <input value={ conf } onChange={ modify } name="conf" className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-password-conf" type="password" placeholder="**********" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-end mt-2">
                <button disabled={ loading } onClick={ () => {
                    if (conf === password) {
                        execute()
                    } else {
                        enqueueSnackbar('Please ensure that your password match', notifOps('warning'))
                    }
                }} type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Changes</button>
            </div>
        </Modal>
    )
}

export default EditUser